import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import banner3 from '../Assets/Leonardo_Phoenix_10_Create_a_series_of_background_images_featu_0.jpg'
import banner from '../Assets/Bilal1.jpg'
// import banner1 from '..'
// import banner2 from '../assets/Leonardo_2.jpg'
import banner4 from '../Assets/Bilal2.jpg'
// import banner5 from '../assets/Leonardo_Phoenix_10_Create_a_series_of_background_images_featu_3 (2).jpg'
import banner10 from '../Assets/Bilal3.jpg'


const SliderContainer = styled.div`
  width: 100%;
  margin: auto;
  /* padding: 20px; */
  box-sizing: border-box;

 
`;

const SlideImage = styled.img`
  width: 100%;
  height: auto; /* Ensures the image maintains its aspect ratio */

  /* Media Queries for responsiveness */
  
  /* For larger screens like laptops */
  @media (min-width: 1024px) {
    width: 100%; /* Full width for laptops */
    height: auto;
  }

  /* For tablets */
  @media (min-width: 768px) and (max-width: 1023px) {
    width: 100%; /* Full width for tablets */
    height: auto;
  }

  /* For mobile phones */
  @media (max-width: 767px) {
    width: 100%; /* Full width for mobiles */
    height: auto;
  }
  @media (max-width: 480px) {
    width: 100%; /* Full width for mobiles */
    height: 500px;
  }
`;

const StyledSlider = styled(Slider)`
 position: relative;
 box-sizing: border-box;
  .slick-prev, .slick-next {
    width: 70px;
    height: 70px;
    z-index: 1; // Ensure the arrows appear above the images
    /* background-color: red; */
  }

  .slick-prev {
    left: 20px;
    box-sizing: border-box;
    top: 40%;
    transform: translateY(-50%);
    @media (max-width:600px) {
top: 50%;
  }
  }

  .slick-next {
    right: 20px;
    box-sizing: border-box;
    top: 40%;
    transform: translateY(-50%);
    @media (max-width:600px) {
top: 50%;
  }
  }

  .slick-prev:before,
  .slick-next:before {
    color: #fdfbfb;
    /* background-color: green; */
    font-size: 50px;
    @media (max-width:600px) {
font-size: 30px;
  }
  }
  .slick-dots {
    position: absolute;
    bottom: 40px; /* Adjust as needed */
    width: 100%;
    display: flex !important;
    justify-content: center;
    z-index: 1; /* Ensure the dots appear above the images */
    
  }

  .slick-dots li button:before {
    color: #fcfbfb;
    /* background-color: red; */
    font-size: 12px;
    @media (max-width:600px) {
font-size: 8px;
  }
  }
  
`;
const OverlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 43%;
  background-color: rgba(255, 255, 255, 0.7);
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  z-index: 2;
  height: 60px;
  width:200px;
  font-size: larger;
  font-weight:bold ;
  color: #6e4a05;
  border-radius: 5px;
  &:hover {
    background-color: rgba(110, 74, 5, 0.7);
    color: white;
    height: 62px;
  width:202px;
  }
`;
const SlideWrapper = styled.div`
  position: relative;
`;
const OverlayLink = styled.a`
  position: absolute;
  top: 50%;
  left: 43%;
  z-index: 2;
  text-decoration: none;
`;


const TittleImage = styled.h1`
   position: absolute;
  top: 60%;
  
  width: 400px;
  padding-top: 90px;
  margin-right: 0px;
  z-index: 3;
  align-items: center;
  text-align: center;
  color:white;
  /* background-color: red; */
  `
const ImageSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // 5 seconds
    arrows: true
  };
  const OverlayText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  width: 100%;
  z-index: 1;
  max-width: 600px;

  @media (max-width: 1024px) {
    width: 75%;
  }

  @media (min-width: 501px) and (max-width: 768px) {
    width: 80%;
    padding: 15px;
    top: 25%;
  }

  
  @media (min-width: 351px) and (max-width: 500px) {
    width: 70%;
    text-align: center;
    justify-content: center;
    align-items: center;
    /* height: 350px; */
    padding: 10px;
    top: 43%;
}
  @media (max-width: 350px) {
    width: 70%;
    text-align: center;
    justify-content: center;
    align-items: center;
    /* height: 350px; */
    padding: 10px;
    top: 45%;
  }
`;

// Headings style
const Head1 = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 2.2rem;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 500px) {
    font-size: 1rem;
    margin-top: 85px;
  }
  
`;

const Head2 = styled.h1`
  font-size: 1.8rem;
  font-weight: normal;
  margin-top: 10px;

  @media (max-width: 1024px) {
    font-size: 1.6rem;
  }

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (max-width: 500px) {
    font-size: 1.3rem;
    margin-top: 2px;
  }
`;

const Head3 = styled.p`
  font-size: 1.2rem;
  font-weight: normal;
  /* color: #000000; */
  margin-top: 20px;

  @media (max-width: 1024px) {
    font-size: 1.1rem;
  }

  @media (max-width: 768px) {
    font-size: 0.7rem;
  }

  @media (max-width: 500px) {
    font-size: 0.6rem;
    margin-top: 2px;
    line-height: 15px;
  }
`;



  const images = [
    // {img:banner3, link: 'https://example.com/link1'},
    { img: banner, link: 'https://example.com/link2' },
    // {img:banner1, link: 'https://example.com/link3'},
    // {img:banner2, link: 'https://example.com/link4'},
    { img: banner4, link: 'https://example.com/link5' },
    // {img:banner5, link: 'https://example.com/link6'},
    // {img:banner14, link: 'https://example.com/link10'},
    { img: banner10, link: 'https://example.com/link7' },
    // {img:banner11, link: 'https://example.com/link8'},
    // {img:banner12, link: 'https://example.com/link9'},
    // {img:banner13, link: 'https://example.com/link10'},

  ];

  return (
    <SliderContainer>
<OverlayText>
              <Head1>Making the Most of Your Spending Power</Head1><br />
              <Head2>Find the greatest prices on your preferred item</Head2><br />
              <Head3>We appreciate you making our affiliate website your go-to online purchasing resource<br></br>We sincerely hope you have fun exploring our website and discovering fantastic offers and goods that satisfy your tastes and requirements</Head3><br />

            </OverlayText>
      <StyledSlider {...settings}>
        {images.map((image, index) => (
          <SlideWrapper key={index}>
            <SlideImage src={image.img} alt={`Slide ${index + 1}`} />
            
            <OverlayLink href={image.link} target="_blank" rel="noopener noreferrer">
            </OverlayLink>
          </SlideWrapper>
        ))}
      </StyledSlider>
    </SliderContainer>
  );
};

export default ImageSlider;


